const codeModule = {
  "101": "未接收到数据",
  "102": "签名验证失败，请重新登录",
  "103": "验证码发送失败",
  "104": "缺少手机号",
  "105": "缺少密码",
  "106": "该号码已注册，请返回登录",
  "111": "注册失败",
  "107": "验证码错误",
  "108": "账号密码不匹配",
  "109": "账号不存在",
  "110": "密码修改失败",
  "112": "退出失败",
  "113": "修改用户信息失败",
  "114": "缺少参数",
  "115": "保存失败",
  "121": "卡信息不完整",
  "122": "没有ID",
  "201": "店铺不存在",
  "202": "餐桌不存在",
  "203": "不可连续留言",
  "204": "用户没有在任何门店消费过",
  "205": "美食广场不存在",
  "206": "店铺未营业",
  "301": "未添加商品类型",
  "302": "商品不存在",
  "303": "已售罄",
  "304": "请输入套餐适用人数",
  "305": "菜品不存在",
  "306": "套餐不存在",
  "307": "不支持店内",
  "308": "不支持配送自提",
  "309": "部分商品库存不足",
  "400": "验证码不正确",
  "401": "配送地址不存在",
  "403": "超出配送范围",
  "404": "购物车中没有商品",
  "405": "请输入用餐人数",
  "407": "请选择餐桌",
  "408": "此餐桌已被锁定",
  "409": "未到起送价格",
  "410": "总金额必须大于1円",
  "411": "添加订单失败，请重试",
  "412": "订单不存在",
  "413": "该订单已支付",
  "415": "订单已评论过",
  "416": "请选择评级",
  "417": "评论失败，请重试",
  "418": "已打印领收书",
  "419": "打印失败",
  "420": "请填写公司名称",
  "421": "订单未评论",
  "422": "支付订单不可取消",
  "423": "取消失败",
  "424": "您没有对此订单操作权限",
  "425": "确认收货失败",
  "426": "该订单不能加菜",
  "427": "信用卡信息错误，请检查",
  "428": "支付失败，请检查后重试",
  "429": "不在自提时间内",
  "430": "不在配送时间内",
  "431": "不支持的支付方式",
  "433": "不在预约时间内",
  "501": "优惠券不存在",
  "502": "已领完",
  "503": "超过单人领取上限",
  "504": "领取失败，请重试",
  "505": "优惠券已使用或者已过期",
  "506": "不满足使用条件",
  "1000": "多规格商品请到购物车中删除!",
  "1001": "确认收货成功"
};

export default codeModule;
